export default "__VITE_ASSET__b131492d__"